export const setHeader = (header) => (dispatch) =>
  dispatch({ type: 'SET_HEADER', payload: header });
